import { StoreState } from '../types';

export const getShowNotification = (state: StoreState): boolean => state.preferences.showNotification;